var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.56252 10.5469H6.98441C6.46664 10.5469 6.04692 10.9666 6.04692 11.4844V18.0937C6.04692 18.6115 6.46664 19.0312 6.98441 19.0312H17.0625C17.5803 19.0312 18 18.6115 18 18.0937V11.4844C18 10.9666 17.5803 10.5469 17.0625 10.5469H14.5312C13.554 10.5469 12.671 10.9587 12.0469 11.6179C11.4227 10.9587 10.5398 10.5469 9.56252 10.5469ZM11.1094 17.1562H7.92191V12.4218H9.56252C10.4155 12.4218 11.1094 13.1158 11.1094 13.9687V17.1562ZM12.9844 13.9687C12.9844 13.1158 13.6783 12.4218 14.5312 12.4218H16.125V17.1562H12.9844V13.9687ZM23.5996 7.9035L12.5372 0.169171C12.2146 -0.0563903 11.7855 -0.0563903 11.4628 0.169171L0.40039 7.9035C-0.0239672 8.20017 -0.12742 8.78465 0.16925 9.20901C0.465967 9.63332 1.0504 9.73677 1.47476 9.44015L2.34382 8.83256V23.0624C2.34382 23.5801 2.76353 23.9999 3.28131 23.9999H20.7187C21.2365 23.9999 21.6562 23.5801 21.6562 23.0624V8.83256L22.5253 9.44015C22.6888 9.55447 22.8761 9.60941 23.0616 9.60941C23.3574 9.60941 23.6484 9.46977 23.8308 9.20901C24.1274 8.7847 24.0239 8.20022 23.5996 7.9035ZM19.7812 22.1249H4.2188V7.52166L12 2.08143L19.7812 7.52166V22.1249Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5,
    y1: 18.9999,
    x2: 21.9999,
    y2: 4.99987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBuilding);
export default __webpack_public_path__ + "static/media/edit_building.3244a2e21a9bc4b9e8617e71951a921a.svg";
export { ForwardRef as ReactComponent };